// extracted by mini-css-extract-plugin
module.exports = {"piecelink":"archive-module--piecelink--iMgQo"};